// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-pools-new-card-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 95%;
  max-width: 384px;
  min-width: 270px;
  height: 200px;
  padding: 24px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #C1C1C1;
}

.my-pools-new-card-logo {
  display: block;
  height: auto;
  max-height: 65px;
  width: auto;
  max-width: calc(100% - 8px);
  object-fit: contain;
  margin-left: 0;
  align-self: flex-start;
}

/* For screens smaller than 768px */
@media (max-width: 899px) {
  .my-pools-new-card-logo {
    max-width: 200px;
  }
}
.my-pools-new-card-title {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #002129;
  text-align: left;
  margin-bottom: 12px !important;
}

.my-pools-new-card-text-row {
  display: flex;
  flex-direction: row;
  justify-content: left;
}

.my-pools-new-card-text-header {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #002129 !important;
  text-align: left;
}

.my-pools-new-card-text-content {
  font-size: 12px !important;
  font-weight: 400 !important;
  color: #002129 !important;
  text-align: left;
}

.my-pools-new-card-button-container {
  display: flex;
  flex-direction: row;
  justify-content: left;
}

.my-pools-new-card-button {
  display: flex;
  align-items: center;
  border: 1px solid #373737 !important;
  border-radius: 4px;
  height: 23px;
  width: auto;
  font-size: 12px !important;
  font-weight: 700 !important;
  white-space: nowrap;
  gap: 6px;
  padding: 4px 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/MyPoolsPage/MyPoolsCard/MyPoolsCardNew.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,cAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;AACJ;;AAEA,mCAAA;AACA;EACI;IACI,gBAAA;EACN;AACF;AAEA;EACI,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,gBAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAAJ","sourcesContent":[".my-pools-new-card-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 95%;\n    max-width: 384px;\n    min-width: 270px;\n    height: 200px;\n    padding: 24px;\n    background-color: #fff;\n    border-radius: 8px;\n    border: 1px solid #C1C1C1;\n  }\n  \n.my-pools-new-card-logo {\n    display: block;\n    height: auto;\n    max-height: 65px;\n    width: auto;\n    max-width: calc(100% - 8px); \n    object-fit: contain;\n    margin-left: 0;\n    align-self: flex-start;\n}\n\n/* For screens smaller than 768px */\n@media (max-width: 899px) {\n    .my-pools-new-card-logo {\n        max-width: 200px;\n    }\n}\n\n.my-pools-new-card-title {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #002129;\n    text-align: left;\n    margin-bottom: 12px !important;\n}\n\n.my-pools-new-card-text-row {\n    display: flex;\n    flex-direction: row;\n    justify-content: left;\n}\n\n.my-pools-new-card-text-header {\n    font-size: 12px !important;\n    font-weight: 700 !important;\n    color: #002129 !important;\n    text-align: left;\n}\n\n.my-pools-new-card-text-content {\n    font-size: 12px !important;\n    font-weight: 400 !important;\n    color: #002129 !important;\n    text-align: left;\n}\n\n.my-pools-new-card-button-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: left;\n}\n\n.my-pools-new-card-button {\n    display: flex;\n    align-items: center;\n    border: 1px solid #373737 !important;\n    border-radius: 4px;\n    height: 23px;\n    width: auto;\n    font-size: 12px !important;\n    font-weight: 700 !important;\n    white-space: nowrap;\n    gap: 6px;\n    padding: 4px 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
